module.exports = "../static/images/47ce45.jpeg";